"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.Key = exports.Switch = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Container = _styledComponents["default"].label.withConfig({
  displayName: "Switchstyle__Container",
  componentId: "sc-1dwguj4-0"
})({
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  fontSize: 0,
  verticalAlign: 'middle'
});

exports.Container = Container;

var Switch = _styledComponents["default"].div.withConfig({
  displayName: "Switchstyle__Switch",
  componentId: "sc-1dwguj4-1"
})(function (_ref) {
  var color = _ref.theme.color;
  return {
    transition: '0.4s',
    background: color.neutral['08'],
    border: "1px solid ".concat(color.brandPrimary.light),
    borderRadius: 30,
    width: 36,
    height: 16
  };
});

exports.Switch = Switch;

var Key = _styledComponents["default"].span.withConfig({
  displayName: "Switchstyle__Key",
  componentId: "sc-1dwguj4-2"
})(function (_ref2) {
  var color = _ref2.theme.color;
  return {
    transition: '0.4s',
    background: color.neutral['08'],
    border: "1px solid ".concat(color.brandPrimary.light),
    display: 'block',
    borderRadius: '50%',
    width: 16,
    height: 16,
    position: 'absolute',
    top: 0,
    left: 0
  };
});

exports.Key = Key;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "Switchstyle__Input",
  componentId: "sc-1dwguj4-3"
})(function (_ref3) {
  var _ref4;

  var color = _ref3.theme.color;
  return _ref4 = {}, _defineProperty(_ref4, ":checked ~ ".concat(Switch), _defineProperty({
    background: color.brandPrimary.light,
    borderColor: color.brandPrimary.dark
  }, Key, {
    transform: 'translateX(20px)',
    borderColor: color.brandPrimary.dark
  })), _defineProperty(_ref4, ":disabled ~ ".concat(Switch), _defineProperty({
    borderColor: color.neutral['04']
  }, Key, {
    borderColor: color.neutral['04']
  })), _defineProperty(_ref4, ":disabled:checked ~ ".concat(Switch), {
    background: color.line.medium
  }), _ref4;
});

exports.Input = Input;